/**
 *	shop-list.conf.js
 */
 
import angular from 'angular';
import shopListDirective from './shop-list.directive.js';
import shopListServ from './shop-list.serv.js';
import shopsInHighlightedBoundsFilter from './shops-in-highlighted-bounds.filter.js';

export default angular.module('shopList', [])
	.directive('shopList', shopListDirective)
	.service('shopListServ', shopListServ)
	.filter('shopsInHighlightedBoundsFilter', shopsInHighlightedBoundsFilter)
	.name;